import React from 'react';
import { View, TextInput, StyleSheet, Platform } from 'react-native';
import theme from '../../constants/theme.style.js';
import CustomText from '../customText/CustomText';

const styles = StyleSheet.create({
  container: {
    marginTop: 8,
    marginBottom: 8,
    paddingBottom: 5,
    borderBottomWidth: 1,
    borderBottomColor: theme.GREY_LIGHT_COLOR,
    ...Platform.select({
      web: {
        maxWidth: 400,
        minWidth: 250,
        display: 'flex',
        justifyContent: 'center',
        alignSelf: 'center',
      },
    }),
  },
  header: {
    fontWeight: theme.FONT_WEIGHT_BOLD,
    marginBottom: 7,
    width: '100%',
    textAlign: 'center',
  },
  input: {
    width: '100%',
    textAlign: 'center',
    ...Platform.select({
      web: {
        outlineColor: 'transparent',
      },
    }),
  },
});

const TextInputForm = ({ text, headline, placeholder, callback, secure, onKeyPress, testID }) => {
  function handleChange(input) {
    callback(input);
  }

  return (
    <View style={styles.container}>
      <CustomText style={styles.header}>{headline}</CustomText>
      <TextInput
        secureTextEntry={secure}
        style={styles.input}
        numberOfLines={1}
        onChangeText={handleChange}
        value={text}
        placeholder={placeholder}
        max={30}
        onKeyPress={onKeyPress}
        testID={testID || 'textInput'}
      />
    </View>
  );
};

export default TextInputForm;
